const DEFAULT_SDP = null;
const DEFAULT_DOMAIN = null;

const track_checkout = true;
const persistentParams = ["cid", "sdp", "domain", "utm_id", "utm_source"];

const forcePixelRules = [
  { from: "x.com", to: "y.com" },
];

function getRootDomain() {
  const parts = window.location.hostname.split('.');
  return '.' + parts.slice(-2).join('.');
}

function setCookie(name, value, maxAgeSeconds = 2592000) {
  if (value === null || value === undefined || value === "") return;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; domain=${getRootDomain()}`;
}

function getCookieValue(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

(function storeInitialQueryParams() {
  const urlParams = new URLSearchParams(window.location.search);
  persistentParams.forEach(param => {
    let value = urlParams.get(param);
    if (value) {
      setCookie(param, value);
    }
  });
})();

(function ensureFallbackPixelConfig() {
  const urlParams = new URLSearchParams(window.location.search);

  const urlSdp = urlParams.get("sdp");
  const cookieSdp = getCookieValue("sdp");
  if (!urlSdp && !cookieSdp && DEFAULT_SDP !== null) {
    setCookie("sdp", DEFAULT_SDP);
  }

  const urlDomain = urlParams.get("domain");
  const cookieDomain = getCookieValue("domain");
  if (!urlDomain && !cookieDomain && DEFAULT_DOMAIN !== null) {
    setCookie("domain", DEFAULT_DOMAIN);
  }
})();

function injectPersistentParamsInUrl() {
  const url = new URL(window.location.href);
  let modified = false;

  persistentParams.forEach(param => {
    if (!url.searchParams.has(param)) {
      let value = getCookieValue(param);
      if (value) {
        url.searchParams.set(param, value);
        modified = true;
      }
    }
  });

  if (modified) {
    window.history.replaceState(null, "", url.toString());
  }
}

['pushState', 'replaceState'].forEach(method => {
  const original = history[method];
  history[method] = function (...args) {
    original.apply(this, args);
    window.dispatchEvent(new Event('urlchange'));
  };
});

window.addEventListener('popstate', () => {
  window.dispatchEvent(new Event('urlchange'));
});

window.addEventListener('urlchange', injectPersistentParamsInUrl);
injectPersistentParamsInUrl();

const iframePixel = document.createElement('div');
iframePixel.id = 'iframePixel';
iframePixel.style.display = 'none';
document.body.insertBefore(iframePixel, document.body.firstChild);

function generateSecretKey() {
  const secretArray = { 0: "Q", 1: "M", 2: "Z", 3: "L", 4: "T", 5: "X", 6: "N", 7: "V", 8: "R", 9: "K" };
  const getRandomLetters = (length) => {
    const letters = 'QMZLTXNVRK';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += letters[Math.floor(Math.random() * letters.length)];
    }
    return result;
  };
  const timestampStr = String(Math.floor(Date.now() / 1000));
  let secret = '';
  for (let i = 0; i < timestampStr.length; i++) {
    const char = timestampStr[i];
    secret += secretArray[char] || '?';
  }
  const prefix = getRandomLetters(10);
  const suffix = getRandomLetters(10);
  return `${prefix}-${secret}-${suffix}`;
}

function getPersistentParamsForIframe() {
  const urlParams = new URLSearchParams(window.location.search);
  const cid = urlParams.get('cid') || getCookieValue('cid');
  const collected = {};
  if (cid) {
    collected['cid'] = cid;
  }
  return collected;
}

function buildTrackingIframeSrc(baseUrl, additionalParams = {}, excludeCid = false) {
  const allParams = {
    ...getPersistentParamsForIframe(),
    ...additionalParams,
    s: generateSecretKey()
  };
  if (excludeCid) delete allParams.cid;
  const query = new URLSearchParams(allParams).toString();
  return `${baseUrl}?${query}`;
}

function getDuplicatedDomains(baseDomain) {
  const domains = [baseDomain];
  forcePixelRules.forEach(rule => {
    if (rule.from === baseDomain) {
      domains.push(rule.to);
    }
  });
  return domains;
}

const subdomainPixel = getCookieValue('sdp');
const baseDomain = getCookieValue('domain');
const custom_domain_pixel = subdomainPixel ? subdomainPixel + "." + baseDomain : null;

if (subdomainPixel && baseDomain) {
  const domainsToTrack = getDuplicatedDomains(baseDomain);

  domainsToTrack.forEach((domain, index) => {
    const fullDomain = `${subdomainPixel}.${domain}`;
    const iframePageView = document.createElement('iframe');
    iframePageView.src = buildTrackingIframeSrc(`https://${fullDomain}/`, { action: "PageView" }, index > 0);
    iframePageView.style.width = "1px";
    iframePageView.style.height = "1px";
    iframePageView.style.border = "0";
    iframePageView.referrerPolicy = "no-referrer";
    iframePageView.id = `iframePixelPageView-${domain.replace(/\./g, '-')}`;
    document.getElementById("iframePixel").appendChild(iframePageView);
  });

  window.QPActionATC = function (variantId, productName, productHandle, productPrice, shopCurrency) {
    domainsToTrack.forEach((domain, index) => {
      const fullDomain = `${subdomainPixel}.${domain}`;
      const iframeAddToCart = document.createElement('iframe');
      iframeAddToCart.src = buildTrackingIframeSrc(`https://${fullDomain}/`, {
        action: "AddToCart",
        price: productPrice,
        currency: shopCurrency,
        variant_id: variantId
      }, index > 0);
      iframeAddToCart.style.width = "1px";
      iframeAddToCart.style.height = "1px";
      iframeAddToCart.style.border = "0";
      iframeAddToCart.referrerPolicy = "no-referrer";
      iframeAddToCart.id = `iframePixelAddToCart-${domain.replace(/\./g, '-')}`;
      document.getElementById("iframePixel").appendChild(iframeAddToCart);
    });
  };
}
